const imageSize = {
    w: 360,
    h: 270
};

export const imagePolicy = `?impolicy=fcrop&w=${imageSize.w}&h=${imageSize.h}`;
